import Vue from 'vue'
import VueRouter from 'vue-router'
import moreRoutes from "./routeAutoImport";
import defRoutes from "@/route.conf";
import P404 from "../views/404"
import CryptoJS from 'crypto-js/index';
import qs from 'qs';

Vue.use(VueRouter)

const routes = [];
routes.push( ...defRoutes );
routes.push( ...moreRoutes );
routes.push( {
  path : '*',
  name: '404',
  component : P404
} )

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL, //项目部署路径
  routes,
  scrollBehavior( to, from, savedPosition ){
    return {x:0,y:0}
  }
})

/**
 * 定义路由拦截器
 */
router.beforeEach((to, from, next) => {
  if( to.path == '/' )
    next( '/index' )
  else if( to.path == '/user/login' ){
    next();
  }else{
    let _isLogin  = sessionStorage.getItem( "USER_ISLOGIN" ) == 'true';
    let _isInWx   = navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger';
    let _appId    = to.meta?.appId || "";
    if( to?.meta?.reqAuth === false ){
        next();
    }else if( !_isLogin && _isInWx && to.path != '/user/login' ){
      /*微信端授权登录流程*/
      let _param  = qs.stringify( to.query );
      let _path       = CryptoJS.enc.Base64.stringify(
          CryptoJS.enc.Utf8.parse( `${to.path}?${_param}` )
      );

      let _redir = encodeURIComponent(`${config.ssoUrl}/wechatPub/webAuth?p=${_path}`);
      let _stat = `${config.appCode}${config.wxmpCode}${config.scenceCode}`;
      let _url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.wxAppId}&redirect_uri=${_redir}&response_type=code&scope=snsapi_userinfo&state=${_stat}#wechat_redirect`

      window.location = _url;
    }else {
		 let _isMatchTag = sessionStorage.getItem( "USER_ISMATCHTAG" )  == 'true'
		 if(!_isMatchTag) {
		 	if( to.path != "/index" ){
		 		next( '/index' );
		 	} else {
		 		next();
		 	}
		 }

      next();

	}
  }
});

router.afterEach(to => {

});

export default router
